export default __webpack_public_path__ + "static/media/winter.2ff1f515.jpg";